import { Controller } from 'react-hook-form';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import SidepanelDefaultRow from '../side-panel/side-panel-default-row';
import { AutocompleteRowProps } from './types';
import Autocomplete from '../autocomplete/autocomplete';
import IconCopy from '../icons/copy-two';

import styles from './transaction.module.css';

export default function SidepanelAutocompleteRow({
  title,
  name,
  value,
  control,
  enableEdit,
  placeholder,
  autocompleteList,
  error,
  disabled,
  withSuffix,
  isLoading,
  setValue,
  onSearchAutocomplete,
  isFixedExchangeCurrency,
  tabIndex,
  withClearButton,
  swap,
  copyValue,
  copyEnabled,
  className,
  hasExternalAccountValue,
  pagination,
  onScroll,
  nextPageIsLoading,
  withInfiniteScroll,
  clearErrors,
}: AutocompleteRowProps): React.JSX.Element {
  const [copyIsSuccess, setCopyIsSuccess] = useState(false);

  const onCopy = () => {
    setCopyIsSuccess(true);
    copy(copyValue as string);

    setTimeout(() => {
      setCopyIsSuccess(false);
    }, 2000);
  };

  let content;

  if (enableEdit) {
    content = (
      <Controller
        name={name}
        control={control}
        defaultValue={value}
        render={({ field }) => (
          <Autocomplete
            key={name}
            title={title}
            list={autocompleteList}
            isLoading={isLoading}
            value={field.value}
            placeholder={placeholder}
            name={name}
            tabIndex={tabIndex}
            withClearButton={withClearButton}
            onChange={(e) => {
              if (error && clearErrors) {
                clearErrors([name]);
              }

              field.onChange(e);

              if (setValue && isFixedExchangeCurrency) {
                setValue('exchangeCurrencyFixedId', e.target.value);
              }

              if (setValue && hasExternalAccountValue) {
                setValue('pspIntegrationAccountId', undefined);
              }
            }}
            onSearch={(searchText) =>
              onSearchAutocomplete && onSearchAutocomplete(name, searchText)
            }
            onInfinateScroll={onScroll ? () => onScroll() : undefined}
            nextPageIsLoading={nextPageIsLoading}
            hasNextPage={pagination?.hasNextPage}
            disabled={disabled}
            withSuffix={withSuffix}
            error={error}
            swap={swap}
            withInfiniteScroll={withInfiniteScroll}
            fullWidth
          />
        )}
      />
    );
  } else {
    content = value;
  }

  return (
    <SidepanelDefaultRow
      title={enableEdit ? undefined : title}
      valueClassName={`${copyEnabled && enableEdit ? styles.rowWithCopy : ''} ${
        copyEnabled && !enableEdit ? styles.readCopyButtonWrapper : ''
      }`}
      wrapperClassName={className || ''}
    >
      {content}
      {copyEnabled && (
        <>
          {enableEdit && (
            <button
              type="button"
              className={`${styles.copyButton} ${
                styles.autocompleteCopyButton
              } ${copyIsSuccess ? styles.success : ''}`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
          {!enableEdit && (
            <button
              type="button"
              className={`${styles.readCopyButton} ${
                copyIsSuccess ? styles.success : ''
              }`}
              onClick={onCopy}
              aria-label="Copy"
            >
              <IconCopy />
            </button>
          )}
        </>
      )}
    </SidepanelDefaultRow>
  );
}
